<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron
                  @click="$router.push({name: 'Settings'})"/>
                {{ $t('health.sensor.title') }}
              </h1>
            </div>
            <alert
              v-if="alertVisible"
              :message="alertMessage"
              :type="alertType">
            </alert>
          </grid-col>
        </grid-row>
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div v-has-feature="'NutriAdmin'">
              <sensor-table
                :chartData="items"/>
            </div>
            <div v-has-feature="'Nutri'">
            <nutri-sensor-table
              :chartData="items"/>
            </div>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {
  faPencilAlt,
  faTrashAlt
} from '@fortawesome/pro-regular-svg-icons';
import {faPlusCircle} from '@fortawesome/pro-solid-svg-icons';
import NutriSensorTable from 'BRAND/components/sensortable/NutriSensorTable.vue';
import SensorTable from 'BRAND/components/sensortable/SensorTable.vue';
import Alert from '@/components/shared/alert/Alert';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import BtnPill from '@/components/shared/buttons/BtnPill';
import Chevron from '@/components/shared/Chevron';
import apiSensor from 'BRAND/api/activeSensorUsers';

export default {
  components: {
    MainLayout,
    GridRow,
    GridCol,
    FontAwesomeIcon,
    OkCancelModal,
    Alert,
    BtnPill,
    Chevron,
    NutriSensorTable,
    SensorTable
  },
  data () {
    return {
      alertVisible: false,
      items: [],
      alertType: '',
      icon: {
        add: faPlusCircle,
        trash: faTrashAlt,
        pencil: faPencilAlt
      },
      breadcrumb: [
        {link: '/settings', nameKey: 'menu.settings'},
        {link: '/user-sensor', nameKey: 'health.sensor.sensor', disabled: true}
      ]
    };
  },
  created () {
    apiSensor.activeSensor(this).then((data) => {
      this.items = data.items;
    });
    const alert = this.$route.params.alert;
    if (alert !== undefined) {
      showAlert(this, this.$t(alert), 'success');
    }
  },
  computed: {
    getBreadcrumb () {
      return this.breadcrumb.map(route => {
        route.name = this.$t(route.nameKey);
        return route;
      });
    }
  }
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2000);
};
</script>

<style lang="scss" >
  @import "src/stylesheets/variables";

  #header {
    display: inline-block;
    width: 100%;
    line-height: 1rem;
  }
  .header-title {
    float: left;
  }
  .header-add-button {
    float: right;
  }
  .header-add-button-icon {
    font-size: 3rem;
    color: $secondary;
  }
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/UserSensorTime.vue